import SvgIcon from '@mui/material/SvgIcon';

export default function DuplicateIcon(props) {
  return (
    <SvgIcon {...props}>
      <rect x="6.5" y="5.5" width="8" height="10" rx="1.5" fill="none" stroke="currentColor"/>
      <path fill="currentColor" fillRule="evenodd" clipRule="evenodd" d="M8.8044 17.1333C8.87301 18.1757 9.74026 19 10.8 19H15.1333C16.7902 19 18.1333 17.6569 18.1333 16V9.80002C18.1333 8.74026 17.3091 7.87301 16.2667 7.8044V8.80884C16.7559 8.87402 17.1333 9.29295 17.1333 9.80002V16C17.1333 17.1046 16.2379 18 15.1333 18H10.8C10.2929 18 9.87402 17.6226 9.80884 17.1333H8.8044Z" />
    </SvgIcon>
  );
}